/**
 * Created by or_p on 4/4/2016.
 */
import pusher from './pusherConnection';
import _ from 'lodash';

class NotificationService {
  static instance = null;
  subscribers = [];

  subscribe = (type, handler) => {
    if (!this.subscribers[type]) {
      this.subscribers[type] = [];
    }
    this.subscribers[type].push(handler);

    const channel = pusher.subscribe(window.___editorData.user.pusher.channel);
    channel.bind(type, data => {
      if (_.isString(data)) {
        data = JSON.parse(data);
      }
      handler(data);
    });
  };

  _notifySubscribers = message => {
    const type = message.type;
    const subscribers = this.subscribers[type];
    if (subscribers) {
      subscribers.forEach(item => {
        item(message);
      });
    }
  };
}

NotificationService.instance = new NotificationService();

export default NotificationService.instance;
